import { render } from "./LoanCard.vue?vue&type=template&id=4525e747&scoped=true"
import script from "./LoanCard.vue?vue&type=script&lang=js"
export * from "./LoanCard.vue?vue&type=script&lang=js"

import "./LoanCard.vue?vue&type=style&index=0&id=4525e747&scoped=true&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4525e747"]])

export default __exports__